import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EligibilityCheckRequest} from '../model/eligibility-check/eligibility-check-request.model';
import {ConfigService} from './config.service';
import {SelectedOption} from '../borrow/eligibility-check/options/option-row/selected-option';
import {retryBackoff} from 'backoff-rxjs';
import {EligibilityCheck} from '../model/eligibility-check/eligibility-check.model';

@Injectable()
export class EligibilityCheckService {
    constructor(private httpClient: HttpClient, private configService: ConfigService) {
    }

    async checkEligibility(request: EligibilityCheckRequest): Promise<EligibilityCheck> {
        const url = `${this.configService.getEligibilityCheckServiceUrl()}/eligibility-check`;
        return EligibilityCheck.from(await this.httpClient.post<EligibilityCheck>(url, request).toPromise());
    }

    async selectCreditOption(option: SelectedOption): Promise<string> {
        const url = `${this.configService.getEligibilityCheckServiceUrl()}/selected-credit-option`;
        const response = await this.httpClient.post<{ id: string }>(url, option).toPromise();
        return response.id;
    }

    async updateSelectedCreditOption(optionId: string, selectedOption: SelectedOption): Promise<void> {
        const url = `${this.configService.getEligibilityCheckServiceUrl()}/selected-credit-option/${optionId}`;
        this.httpClient.put(url, selectedOption).pipe(retryBackoff(1000)).subscribe();
    }

    async getSelectedCreditOption(optionId: string): Promise<SelectedOption> {
        const url = `${this.configService.getEligibilityCheckServiceUrl()}/selected-credit-option/${optionId}`;
        return SelectedOption.from(await this.httpClient.get<any>(url).toPromise());
    }

    async getSelectedCreditOptionByLoanApplicationId(loanApplicationId: string): Promise<SelectedOption> {
        const url = `${this.configService.getEligibilityCheckServiceUrl()}/selected-credit-option?loanApplicationId=${loanApplicationId}`;
        return SelectedOption.from(await this.httpClient.get<any>(url).toPromise());
    }
}
